/* Møbelkompagniet footer — nyhedsbrev-signup via Klaviyo Client Subscriptions API.
   Bruger public key (company_id) client-side. Ingen private key i temaet. */
(function () {
  'use strict';

  function initForm(form) {
    if (form.dataset.mkfInit) return;
    form.dataset.mkfInit = '1';

    var cfg = window.mkFooterKlaviyo || {};
    var wrap = form.closest('[data-mkf-signup-wrap]') || form.parentNode;
    var msgEl = wrap.querySelector('[data-mkf-msg]');
    var btn = form.querySelector('button[type="submit"]');
    var emailInput = form.querySelector('input[type="email"]');
    var nameInput = form.querySelector('input[data-mkf-name]');

    function setMsg(text, state) {
      if (!msgEl) return;
      msgEl.textContent = text || '';
      if (state) { msgEl.setAttribute('data-state', state); }
      else { msgEl.removeAttribute('data-state'); }
    }

    function targetList() {
      var de = cfg.listIdDe;
      if (de) {
        var lang = (document.documentElement.lang || '').toLowerCase();
        var country = (window.Shopify && window.Shopify.country ? String(window.Shopify.country) : '').toUpperCase();
        if (lang.indexOf('de') === 0 || country === 'DE') return de;
      }
      return cfg.listId;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = ((emailInput && emailInput.value) || '').trim();
      var list = targetList();

      if (!email) { setMsg(cfg.errorText || 'Indtast en gyldig e-mailadresse.', 'error'); return; }
      if (!cfg.publicKey || !list) { setMsg(cfg.errorText || 'Nyhedsbrevet er ikke konfigureret endnu.', 'error'); return; }

      // Bemaerk: IKKE noget subscriptions-objekt — Klaviyo defaulter til MARKETING-consent.
      // Et eksplicit subscriptions-felt under profile giver HTTP 400 i revision 2024-10-15
      // (samme laere som AI-visualizeren).
      var attrs = { email: email };
      var name = nameInput && nameInput.value.trim();
      if (name) { attrs.first_name = name; }

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: cfg.source || 'Footer',
            profile: { data: { type: 'profile', attributes: attrs } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      };

      if (btn) { btn.disabled = true; }
      setMsg(cfg.loadingText || 'Sender…', '');

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(cfg.publicKey), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': cfg.revision || '2024-10-15'
        },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (r.status === 202 || (r.status >= 200 && r.status < 300)) {
            setMsg(cfg.successText || 'Tak! Du er nu tilmeldt.', 'success');
            form.reset();
            return;
          }
          return r.text().then(function (t) { throw new Error(t || ('HTTP ' + r.status)); });
        })
        .catch(function (err) {
          setMsg(cfg.errorText || 'Noget gik galt. Prøv venligst igen.', 'error');
          if (window.console && console.warn) { console.warn('[mk-footer] Klaviyo subscribe failed:', err && err.message); }
        })
        .then(function () { if (btn) { btn.disabled = false; } });
    });
  }

  function initAll(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('form[data-mkf-signup]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
